import { FlexBox } from '../../components/Base/Base'
import { TeamV3 } from '../../models/team'

interface OverviewSectionProps {
  team: TeamV3
}

export function OverviewSection({ team }: OverviewSectionProps) {
  return (
    <FlexBox isColumn styles="padding: 24px 36px;">
      <h2>Overview</h2>
      <h4>{team.name}</h4>
    </FlexBox>
  )
}
